import type { TenantSimple } from '../tenant.types';

export class TenantSimpleModel {
  private readonly _dto: TenantSimple;

  constructor(dto: TenantSimple) {
    this._dto = dto;
  }

  get originDTO(): TenantSimple {
    return this._dto;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get tenantCode(): string {
    return this._dto.tenantCode || '';
  }

  get description(): string {
    return this._dto.description || '';
  }

  get name(): string {
    return this._dto.name || '';
  }
}
